// src/popups/ExplanationPopup.jsx
import React from "react";
import "./ExplanationPopup.css"; // Creează sau folosește fișierul tău de CSS

const ExplanationPopup = ({ explanation, onContinue }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div
          className="popup-text"
          dangerouslySetInnerHTML={{ __html: explanation }}
        />
        <button className="popup-button" onClick={onContinue}>
          Continua
        </button>
      </div>
    </div>
  );
};

export default ExplanationPopup;
